// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testmode-with-controls {
  display: flex;
  height: 100vh;
  height: 100dvh;
  width: 100%;
  min-height: 0;
  min-width: 0;
  max-width: 100vw;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.testmode-with-controls > .screen {
  flex: 1 1 auto;
  height: auto;
  width: 100%;
  min-height: 0;
  min-width: 0;
}

.testmode-with-controls > .play {
  position: relative;
  top: auto;
  left: auto;
  transform: none;
}

.testmode-controls {
  position: relative;
  z-index: 90;
  display: flex;
  flex: 0 0 auto;
  max-width: calc(100vw - 20px);
  align-items: center;
  align-self: center;
  flex-wrap: nowrap;
  justify-content: flex-end;
  gap: 6px;
  margin: 6px 10px 10px;
  padding: 5px;
  border: 1px solid var(--palette-border);
  border-radius: 12px;
  background: color-mix(in srgb, var(--palette-surface) 94%, transparent);
  box-shadow: 0 5px 18px rgba(28, 27, 26, 0.16);
  backdrop-filter: blur(5px);
}

.testmode-controls span {
  flex: 0 0 auto;
  color: var(--palette-text-muted);
  font-size: 0.68rem;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.testmode-controls button {
  min-height: 36px;
  border: 1px solid var(--palette-border);
  border-radius: 8px;
  padding: 6px 9px;
  color: var(--palette-text);
  background: var(--palette-surface);
  font: 600 0.76rem var(--font-ui);
  cursor: pointer;
}

.testmode-controls button:first-child {
  border-color: var(--palette-secondary);
  color: var(--palette-secondary);
}

.testmode-controls button:focus-visible {
  outline: 2px solid var(--palette-secondary);
  outline-offset: 2px;
}

@media (max-width: 360px) {
  .testmode-controls span {
    font-size: 0.64rem;
  }

  .testmode-controls button {
    padding-inline: 7px;
    font-size: 0.72rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/testModeControls.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,WAAW;EACX,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,QAAQ;EACR,qBAAqB;EACrB,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,uEAAuE;EACvE,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF","sourcesContent":[".testmode-with-controls {\n  display: flex;\n  height: 100vh;\n  height: 100dvh;\n  width: 100%;\n  min-height: 0;\n  min-width: 0;\n  max-width: 100vw;\n  flex-direction: column;\n  overflow: hidden;\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n}\n\n.testmode-with-controls > .screen {\n  flex: 1 1 auto;\n  height: auto;\n  width: 100%;\n  min-height: 0;\n  min-width: 0;\n}\n\n.testmode-with-controls > .play {\n  position: relative;\n  top: auto;\n  left: auto;\n  transform: none;\n}\n\n.testmode-controls {\n  position: relative;\n  z-index: 90;\n  display: flex;\n  flex: 0 0 auto;\n  max-width: calc(100vw - 20px);\n  align-items: center;\n  align-self: center;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  gap: 6px;\n  margin: 6px 10px 10px;\n  padding: 5px;\n  border: 1px solid var(--palette-border);\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--palette-surface) 94%, transparent);\n  box-shadow: 0 5px 18px rgba(28, 27, 26, 0.16);\n  backdrop-filter: blur(5px);\n}\n\n.testmode-controls span {\n  flex: 0 0 auto;\n  color: var(--palette-text-muted);\n  font-size: 0.68rem;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.testmode-controls button {\n  min-height: 36px;\n  border: 1px solid var(--palette-border);\n  border-radius: 8px;\n  padding: 6px 9px;\n  color: var(--palette-text);\n  background: var(--palette-surface);\n  font: 600 0.76rem var(--font-ui);\n  cursor: pointer;\n}\n\n.testmode-controls button:first-child {\n  border-color: var(--palette-secondary);\n  color: var(--palette-secondary);\n}\n\n.testmode-controls button:focus-visible {\n  outline: 2px solid var(--palette-secondary);\n  outline-offset: 2px;\n}\n\n@media (max-width: 360px) {\n  .testmode-controls span {\n    font-size: 0.64rem;\n  }\n\n  .testmode-controls button {\n    padding-inline: 7px;\n    font-size: 0.72rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
